import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonFunctionService } from '../Common/common-function.service';
import { VposVaultAppView } from 'src/app/models/vpos-vault-app-view';
import { catchError, map } from 'rxjs';

@Injectable()
export class SecureVaultService {

  constructor(private service: DataService,private http: HttpClient, private common:CommonFunctionService) {  }
  
  GetVaults(data)
  {
    return this.http.get<VposVaultAppView>(environment.getVaultUrl+"?merchantKeyId="+data)  
    .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));
  } 

  GetVaultById(data,merchantKeyId)
  {
    return this.http.get<VposVaultAppView>(environment.ViewVaultUrl+'?id='+data + '&merchantkeyid='+merchantKeyId);
  }

  GetVaultByEmailAccountNo(merchantKeyId,Email,AccountNo)
  {
    return this.http.get<VposVaultAppView>(environment.GetVaultByEmailAccountNoUrl+'?MerchantKeyId='+merchantKeyId + '&Email='+Email + '&AccountNumber='+AccountNo);
  }

  AddNewVault(data,email)
  {   
    return this.service.create(environment.AddVaultUrl+"?Email="+email, data);
  }
  // UpdateVault(data,id)
  // {   
  //   return this.service.create(environment.UpdateVaultUrl+"?id="+id, data);
  // }
  deleteVault(data,Email)
  {
   return this.service.create(environment.DeleteVaultUrl+"?Email="+Email, data);
  }

}
